import { TipoArticulo, useGetRecetasProcesosLazyQuery } from "src/gql/schema"
import { useEffect, useState } from "react"
import { AlmacenArticulo } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { FilterSortState } from "../interfaces/filterSortState"
import { PathNames } from "../interfaces/pathnames"
import { getRecetasProcesosQueryFilters } from "../helpers/getRecetasProcesosQueryFilters"

export const TODOS_CATEGORIA_FILTER = { label: "Todo", value: "" }

const useGetRecetasProcesos = ({
    page,
    categoria_tipoSelected,
    categorias_tipo,
    filterSortState,
    articleFromSearch,
}: {
    articleFromSearch?: AlmacenArticulo | null
    page: number
    categoria_tipoSelected: {
        name: PathNames | TipoArticulo.Proceso
        id: string
    }
    categorias_tipo: {
        name: PathNames | TipoArticulo.Proceso
        id: string
    }[]
    filterSortState?: FilterSortState
}) => {
    const [getRecetasProcesos] = useGetRecetasProcesosLazyQuery()
    const { hotel_id } = useProfile()
    const [isLoading, setisLoading] = useState(true)
    const [articulos, setarticulos] = useState<{ articulos: AlmacenArticulo[]; totalPages: number; currentPage: number } | null>(null)

    useEffect(() => {
        setarticulos(null)
    }, [filterSortState])

    useEffect(() => {
        if (
            !categorias_tipo.length ||
            !categoria_tipoSelected.name
        ) {
            return
        }
        setisLoading(true)
        getRecetasProcesos({
            variables: getRecetasProcesosQueryFilters({
                categoria_tipoSelected: categoria_tipoSelected,
                categorias_tipo,
                hotel_id,
                page,
                filterSortState,
            }),
        }).then((data) => {
            if (!data.data?.almacenes_articulos) {
                return
            }
            const updatedArticulos = {
                currentPage: data.data.almacenes_articulos.paginacion.pagina_actual,
                totalPages: data.data.almacenes_articulos.paginacion.total_paginas,
                articulos: (data.data?.almacenes_articulos.almacenes_articulos as AlmacenArticulo[]) || [],
            }
            setarticulos(updatedArticulos)
            setisLoading(false)
        })
    }, [page, filterSortState])

    useEffect(() => {
        if(articleFromSearch) {
            return setarticulos({
                articulos: [articleFromSearch],
                currentPage: 1,
                totalPages: 1
            })
        }
        if (
            !categorias_tipo.length ||
            !categoria_tipoSelected.name
        ) {
            return
        }
        setisLoading(true)
        getRecetasProcesos({
            variables: getRecetasProcesosQueryFilters({
                categoria_tipoSelected: categoria_tipoSelected,
                categorias_tipo,
                hotel_id,
                page,
                filterSortState,
            }),
        }).then((data) => {
            if (!data.data?.almacenes_articulos) {
                return
            }

            const updatedArticulos = {
                currentPage: data.data.almacenes_articulos.paginacion.pagina_actual,
                totalPages: data.data.almacenes_articulos.paginacion.total_paginas,
                articulos: (data.data?.almacenes_articulos.almacenes_articulos as AlmacenArticulo[]) || [],
            }
            setarticulos(updatedArticulos)
            setisLoading(false)
        })
    }, [categoria_tipoSelected, categorias_tipo, articleFromSearch])

    const refetch = async ({ almacenSelected, page }: { almacenSelected: string; page: number }) => {
        setisLoading(true)
        return await getRecetasProcesos({
            variables: getRecetasProcesosQueryFilters({
                categoria_tipoSelected: categoria_tipoSelected,
                categorias_tipo,
                hotel_id,
                page,
                filterSortState,
            }),
        }).then((data) => {
            if (!data.data?.almacenes_articulos) {
                return
            }
            const articulosUpdated = {
                currentPage: data.data.almacenes_articulos.paginacion.pagina_actual,
                totalPages: data.data.almacenes_articulos.paginacion.total_paginas,
                articulos: (data.data?.almacenes_articulos.almacenes_articulos as AlmacenArticulo[]) || [],
            }
            setarticulos(articulosUpdated)
            setisLoading(false)
        })
    }

    return {
        articulos: articulos?.articulos,
        refetch,
        currentPage: articulos?.currentPage,
        totalPages: articulos?.totalPages,
        isLoading,
    }
}

export default useGetRecetasProcesos
